<!-- criteo連携情報 -->
<!-- value="" としている箇所は往復空席照会と同じ値を設定する-->
<input id="criteo_segment_code" type="hidden" name="criteoSegmentCode" value="{{ criteo.segmentCode }}" />
<input id="criteo_device_type" type="hidden" name="criteoDeviceType" value="{{ criteo.deviceType }}" />
<input id="criteo_departure_date" type="hidden" name="criteo_DepartureDate" value="{{ criteo.departureDate }}" />
<input id="criteo_arrival_date" type="hidden" name="criteoArrivalDate" value="{{ criteo.arrivalDate }}" />
<input id="criteo_connection_kind" type="hidden" name="criteoConnectionKind" value="{{ criteo.connectionKind }}" />
<input id="criteo_language_code" type="hidden" name="criteoLanguageCode" value="{{ criteo.languageCode }}" />
<input id="criteo_search_mode" type="hidden" name="criteoSearchMode" value="{{ criteo.searchMode }}" />
<input id="criteo_adult_count" type="hidden" name="criteoAdultCount" value="{{ criteo.adultCount }}" />

<input id="criteo_child_count" type="hidden" name="criteoChildCount" value="{{ criteo.childCount }}" />
<input id="criteo_infant_count" type="hidden" name="criteoInfantCount" value="{{ criteo.infantCount }}" />
<input id="criteo_boarding_class" type="hidden" name="criteoBoardingClass" value="{{ criteo.boardingClass }}" />
<input
  id="criteo_boarding_class_option"
  type="hidden"
  name="criteoBoardingClassOption"
  value="{{ criteo.boardingClassOption }}"
/>
<input id="criteo_total_amount" type="hidden" name="criteoTotalAmount" value="{{ criteo.totalAmount }}" />
<input id="criteo_transaction_id" type="hidden" name="criteoTransactionId" value="{{ criteo.transactionId }}" />
<input id="criteo_customer_type" type="hidden" name="criteoCustomerType" value="{{ criteo.customerType }}" />
